import { createModel } from "hox";
import {IVehicleSearch,IVehicleParams,IVehicleDetail,IVehicleInsert,IVehicleUpdata,IVehicleDisable} from "./vehicleTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { vehicleService } from "./vehicleService"
import useMdmModel from "../../../model/mdmModel"
import moment,{Moment} from "moment";

export const useVehicleModel = createModel(function () {
    const {customer} = useMdmModel()
    const initSearchParams: IVehicleParams = {}
    const initDataSource: IVehicleDetail[] = []
    const initAddParam: IVehicleInsert = {enable:true,branch:"main"}
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IVehicleParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IVehicleDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IVehicleDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IVehicleInsert>(initAddParam);
    //使用性质
    const [nature, setNature] = useState<Optios[]>([]);
    //车辆类型
    const [vehicletype, setVehicletype] = useState<Optios[]>([]);

    const upDataSearchParam = (upDataParam: IVehicleParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IVehicleParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await vehicleService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        const newRecords = records.map((item,index)=>{
            return {
                ...item,
                registerDate:item.registerDate?moment(item.registerDate):item.registerDate,
                createTime:item.createTime?moment(item.createTime):item.createTime,    
                productionTime:item.productionTime?moment(item.productionTime):item.productionTime,                
                deliveryTime:item.deliveryTime?moment(item.deliveryTime):item.deliveryTime,                
            }
        })
        setDataSource(newRecords)
    }
    const updataAddParam = (updateParam: IVehicleInsert) => {
        let newUpdateParam = updateParam
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IVehicleDetail) => {
        let newUpdateParam = updateParam
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IVehicleInsert) => {
        const param = {
            ...addParam,
            sourceApp: "mdm",
            enable: addParam.enable ? 1 : 0,
            registerDate:addParam.registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            productionTime:addParam.registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            deliveryTime:addParam.registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            categoryName:findOption(addParam.categoryCode as string,vehicletype)?.label,
            natureName:findOption(addParam.natureCode as string,nature)?.label,
            customerName:findOption(addParam.customerCode as string,customer)?.label,
        }
        const { retData, retMsg } = await vehicleService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData 
    }
    const updataDetail = async (params: IVehicleDetail) => {
        const param = {
            ...selectedRow[0],
            enable: selectedRow[0].enable ? 1 : 0,
            registerDate:selectedRow[0].registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            productionTime:selectedRow[0].registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            deliveryTime:selectedRow[0].registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,            
            createTime:selectedRow[0].createTime?.format('YYYY-MM-DD HH:mm:ss') as any,                
            categoryName:findOption(addParam.categoryCode as string,vehicletype)?.label,
            natureName:findOption(addParam.natureCode as string,nature)?.label,
            customerName:findOption(addParam.customerCode as string,customer)?.label,
        }
        const { retData, retMsg } = await vehicleService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData 
    }
    const cutDisabled = async (params: IVehicleDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0,
            registerDate:params.registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            productionTime:params.registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,
            deliveryTime:params.registerDate?.format('YYYY-MM-DD HH:mm:ss') as any,            
            createTime:params.createTime?.format('YYYY-MM-DD HH:mm:ss') as any,                
            categoryName:findOption(addParam.categoryCode as string,vehicletype)?.label,
            natureName:findOption(addParam.natureCode as string,nature)?.label,
            customerName:findOption(addParam.customerCode as string,customer)?.label,
        }
        const { retData, retMsg } = await vehicleService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        nature,
        vehicletype,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setVehicletype,
        setNature
    }
});